<template>
  <div name="hrms41e-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-4 clear-padding">{{ labels['HRMS41EC2']['30'] }} {{ dataGroup.numgrup }}</div>
        <div class="col-xs-12 col-md-8 clear-padding evaluation-title">{{ dataGroup.desgrup }}</div>
      </div>
      <div class="col-xs-4 clear-padding evaluation-score">{{ calResultScore(dataGroup) }}/{{ calTotalScore(dataGroup) }}</div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <template v-for="(item, index) in dataGroup.numitem">
          <hrms41e-item :dataGroup="dataGroup"
                        :labels="labels"
                        :item="item"
                        :choices="choices"
                        :name="name" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import hrms41eItem from 'components/hrms41e/item'

export default {
  name: 'hrms41e-group',
  data () {
    return {
      groupDisp: false
    }
  },
  props: {
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    },
    calResultScore (dataGroup) {
      let groupQtyscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyscor', groupQtyscor)
      return groupQtyscor
    },
    calTotalScore (dataGroup) {
      let groupQtyfscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyfscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyfscor', groupQtyfscor)
      return groupQtyfscor
    }
  },
  components: {
    hrms41eItem
  }
}
</script>


// WEBPACK FOOTER //
// group.vue?0c5d13bc